export default __webpack_public_path__ + "static/media/4128.620e6cb0.png";